import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Layer } from 'components'
import styles from './index.module.css'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { showTermsAgreeDetailLayerState, showTermsAgreeDetailContentsLayerState } from './states'
import TermsAgreeDetailContentsLayer from './TermsAgreeDetailContents'
import Lib from 'library'

const TermsAgreeDetail = ({ termsOptnlDetail }) => {

	const App = useApp()
	const [showTermsAgreeDetailLayer, setShowTermsAgreeDetailLayer] = useRecoilState(showTermsAgreeDetailLayerState)
	const setShowTermsAgreeDetailContentsLayer = useSetRecoilState(showTermsAgreeDetailContentsLayerState)

	const [termsContentsLst, setTermsContentsLst] = useState()
	const [ctgry, setCtgry] = useState("Service")
	const [thinkPoolPay, setThinkPoolPay] = useState(); // 씽크풀 결제 정보

	useEffect(() => {
		getThinkPoolPayInfo(); // 씽크풀 결제정보 조회
	}, [])

	//철회하기
	const onButton = () => {
		let confirmMsg = "";

		if (termsOptnlDetail.termsCtgryCd !== "STOCK") {
			confirmMsg = "서비스 이용을 철회할까요?";
		} else {
			confirmMsg = "제 3자 제공 동의 철회 시 My Stock Manager 서비스(유료서비스 포함)를 더 이상 이용하실 수 없습니다.";
		}

		App.confirm({
			msg: confirmMsg,
			onOk: runAgreeCancel,
			ok: "철회하기",
			cancel: "취소",
			type: "bottom"
		})
	}

	// 철회 실행
	const runAgreeCancel = () => {

		if (termsOptnlDetail && termsOptnlDetail.termsCtgryCd === "STOCK" && thinkPoolPay && thinkPoolPay.payYn === "Y") { // 씽크풀 결제가 된 경우는 약관을 철회할 수 없음.
			let msg = `이용중인 상품이 있어 철회가 불가능해요.<br/>상품 이용 종료일${thinkPoolPay && thinkPoolPay.payEndDate.length >= 10 ? `(${thinkPoolPay.payEndDate.substring(0, 10).replace(/-/g, ".")})` : ``} 후에<br/>철회해주세요.`;

			App.showAlert(msg, () => {
				setShowTermsAgreeDetailLayer(false)
			})
		} else {
			Lib.post(`/api/more/etc/terms/upd/agree/${termsOptnlDetail.termsCtgryCd}`, {
				agreeYn: termsOptnlDetail.agreeYn === "Y" ? "N" : "Y",
				termsCtgryCd: termsOptnlDetail.termsCtgryCd
			}, data => {
				let msg
				if (termsOptnlDetail.agreeYn === "Y") {
					//console.log("termsOptnlDetail", termsOptnlDetail);
					if (termsOptnlDetail && termsOptnlDetail.termsCtgryCd === "STOCK") {
						msg = "My Stock Manager 서비스 이용이<br/>철회되었어요."
					} else {
						msg = "철회되었습니다."
					}

				}
				App.showAlert(msg, () => {
					setShowTermsAgreeDetailLayer(false)
				})
			})
		}

	}

	const showOptnlContentsLayer = terms => {
		setShowTermsAgreeDetailContentsLayer(true)
		setTermsContentsLst(terms)
	}

	// 씽크풀 결제정보 조회
	const getThinkPoolPayInfo = () => {
		Lib.post("/api/inner/thinkpool/payInfo", data => {
			//console.log("getThinkPoolPayInfo", data)
			setThinkPoolPay(data);
		})
	}

	return (
		<Layer show={showTermsAgreeDetailLayer} closeLayer={() => setShowTermsAgreeDetailLayer(false)}>
			<div className="page">
				<div className="flex_1 padding">
					<div className={styles.title}>{termsOptnlDetail?.termsCtgryNm}</div>
					<ul className={`${styles["link-menu"]} mt_40`}>
						{termsOptnlDetail &&
							termsOptnlDetail.termsList.map((item, index) => {
								return (
									<li key={index}>
										<div className={styles.linkSpan} onClick={() => showOptnlContentsLayer(item)}>
											<p>{item.termsNm}</p>
											<i className="icon icon_arrow_sm right ml_5" />
										</div>
									</li>
								)
							})

						}
					</ul>
					<div className={`${styles["question-box"]} mt_50`}>
						<p>동의 철회를 원하시나요?</p>
						<ul className="mt_10">
							<li>동의 철회시 본 서비스와 관련된 모든 정보가 삭제되며, 복구할 수 없습니다.(단, 관련 법령에 따라 보존할 필요가 있는 경우는 해당보존기간동안 보관합니다.)</li>
							<li>회원님의 금융거래를 정상적으로 처리하기 위해 동의 유지가 필수적인 경우, 즉시 철회가 불가할 수 있습니다.</li>
						</ul>
					</div>
				</div>
				<div className="flex-shrink_0 padding">
					<Button className="btn btn--big btn--dark" onClick={onButton}>철회하기</Button>
				</div>
			</div>

			<TermsAgreeDetailContentsLayer termsContentsLst={termsContentsLst} ctgry={ctgry} />
		</Layer>
	)
}

export default TermsAgreeDetail
